<template>
  <div v-if="demandesLogistiques && critereRecherche">
    <div class="columns level">
      <div class="column is-6 pdt-0 level-left">
        <div class="columns mgt-0">
          <div class="column is-narrow pdt-0">
            <b-datepicker :value="dateSelect"
                          show-week-number
                          @input="$emit('changeDateSelect', $event)"
                          :date-formatter="formatageOuputDatepicker"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          :editable="true"
                          class="width-250">
            </b-datepicker>
          </div>
        </div>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllDemandeSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="critereRecherche.auto = filter"
                class="column is-4 pdr-0">
            <b-input :placeholder="$t('listeDemande.actions.search')"
                     type="search" icon="magnify" v-model="filter">
            </b-input>
          </form>
          <div class="column is-narrow pdr-0">
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"/>
              <span class="is-size-7">
                          {{$t('general.button.filtre')}}
                          <label
                            class="has-text-weight-bold"
                            :class="nombreCritere > 0 ? '' : 'is-invisible'">
                            ({{ nombreCritere }})
                          </label>
                        </span>
            </button>
            <span
              class="info-circle-right is-pulled-right is-cursor-pointer"
              @click="reinitialiserFiltre()">
                        <b-icon icon="close-circle" type="is-danger"/>
                      </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permDemande.exporter"
            :action="exportExcel"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-client-table
      v-if="startArrayRendering"
      :data="listeDemandesFilter"
      :columns="columns"
      :options="options"
      class="overflow-x-auto"
      :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props">
        <b-checkbox @input="updateValue(props.row.id, $event)"
                    :value="props.row.selected"></b-checkbox>
      </div>
      <div slot="codeCommande" slot-scope="props">
        <div v-if ="props.row.ligneCommande">
          <router-link-blank
            :to="{ name: 'c.bodac.commandes',
                    params: {id: props.row.ligneCommande.devisCommandeId}}"
            :message="props.row.ligneCommande.codeCommande"></router-link-blank>
        </div>
      </div>
      <div slot="jourDepart" slot-scope="props">
        <div v-if ="props.row.ligneCommande">
          {{ getJourDeLaSemaine(props.row.ligneCommande.jourDepart) }}
        </div>
      </div>
      <div slot="annonceurs" slot-scope="props">
        <div v-if ="props.row.ligneCommande">
          {{ props.row.ligneCommande.annonceurs }}
        </div>
      </div>
      <div slot="commercial" slot-scope="props">
        <div v-if ="props.row.ligneCommande">
          {{ props.row.ligneCommande.commercial }}
        </div>
      </div>
      <div slot="theme" slot-scope="props">
        <div v-if ="props.row.ligneCommande">
          {{ props.row.ligneCommande.theme }}
        </div>
      </div>
      <div slot="libelleProduit" slot-scope="props">
        <router-link-blank :to="{ name: getLibelleAndRoutesForProduct(props.row).routeDetail,
                params: {id: props.row.produitId?
                  props.row.produitId: props.row.ligneCommande.produitId}}"
                           class="lien"
                           :message="props.row.libelleProduit ">
        </router-link-blank>
      </div>
      <div slot="dateDebutAffichage" slot-scope="props">
        <div v-if ="props.row.ligneCommande">
          <b-tooltip :label="$t('listeDemande.info.dateAffichageIdentiqueLogistique' )"
                     type="is-warning"
                     v-if="aAffichageMemeSemaine(props.row)"
                     position="is-left">
            <b-icon icon="alert" size="is-small" type="is-warning"></b-icon>
            <span v-if="props.row.ligneCommande.datePlanifieeLogistiqueAffichage">
                      {{ props.row.ligneCommande.datePlanifieeLogistiqueAffichage | formatDate }}
                    </span>
            <span v-else>
                      {{ props.row.ligneCommande.dateDebut | formatDate }}
                    </span>
          </b-tooltip>
          <div v-else>
                    <span v-if="props.row.ligneCommande.datePlanifieeLogistiqueAffichage">
                      {{ props.row.ligneCommande.datePlanifieeLogistiqueAffichage | formatDate }}
                    </span>
            <span v-else>
                      {{ props.row.ligneCommande.dateDebut | formatDate }}
                    </span>
          </div>
        </div>
      </div>
      <div slot="datePlanification" slot-scope="props">
        {{ props.row.datePlanification | formatDate }}
      </div>
      <div slot="dateFinAffichage" slot-scope="props">
        <div v-if ="props.row.ligneCommande">
          {{ props.row.ligneCommande.dateFin | formatDate }}
        </div>
      </div>
      <div slot="semaine" slot-scope="props">
        <div v-if ="props.row.ligneCommande">
          {{ getSemaine(props.row.ligneCommande) }}
        </div>
      </div>
      <div slot="facesVendues" class="is-pulled-right" slot-scope="props">
        {{ props.row.facesDemandees ?
        props.row.facesDemandees : 0 }}
      </div>
      <div slot="facesAffectees" class="is-pulled-right" slot-scope="props">
        {{ props.row.facesAffectees ?
        props.row.facesAffectees : 0 }}
      </div>
      <div slot="typeProduit" slot-scope="props">
        <div>
          {{ $t(getLibelleTypeProduit(props.row.typeProduit)) }}
        </div>
      </div>
      <div slot="couleur" slot-scope="props">
        <b-icon v-if="estAffectee(props.row)"
                icon="circle" size="is-small"
                :type="'is-success'"/>
        <b-tooltip v-else-if="getMessageEchecAffectation(props.row)"
                   type="is-warning"
                   position="is-left">
          <template v-slot:content>
            <b> {{$t('listeDemande.tab.echec.title')}} : </b>
            <ul>
              <li v-for="(message, $index) in getMessageEchecAffectation(props.row)"
                  :key="$index">
                - {{message}}
              </li>
            </ul>
          </template>
          <b-icon icon="circle" size="is-small"
                  :type="'is-danger'"/>
        </b-tooltip>
        <b-icon v-else
                icon="circle" size="is-small"
                :type="'is-danger'"/>
      </div>
      <div slot="etat" slot-scope="props">
        {{ getEtatDemande(props.row) }}
      </div>
      <div slot="modifier" slot-scope="props">
        <a @click=" modifier(props.row)">
          <b-icon
            icon="pencil-box-outline"
            type="is-success"
            :class="{ 'text-access-no-permission':
                        !checkPermissions(permDemande.maj) || props.row.estDansOtAffichage}">
          </b-icon>
        </a>
      </div>
      <div slot="affecter" slot-scope="props">
        <a class="button is-primary is-fullwidth"
           :class="{ 'button-access-no-permission':
                !checkPermissions(permAffectation.maj)
                || !isRegroupement(props.row.typeProduit) }"
           @click="allerAAffecter(props.row)">
          <b-icon icon="link"></b-icon>
          <span class="mgr-5px>">{{ $t('listeDemande.tab.actions.affecter') }}</span>
        </a>
      </div>

    </v-client-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-demande
          ref="filtreDemande"
          :type="constantes.TYPE_DEMANDE_LOGISTIQUE"
          @close="makeRechercheFilter"
          @toggleFiltre="setShowFiltre"/>
      </div>
    </transition>
    <b-modal v-model="popUpModification" has-modal-card class="modal">
      <pop-up-modifier
        :demandeLogistique="ligneAModifier"
        @refreshList="$emit('refreshList')">
      </pop-up-modifier>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="idsToDelete.length === 1
          ? this.$t('listeDemande.popUpSuppression.title')
          : this.$t('listeDemande.popUpSuppression.titleMutlti')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :isErrorPopup.sync='isErrorPopup'
        :messagesPopup='messagesPopup'
        @no="popUpSuppression = false"
        @yes="deleteMassDemandeLogistique()"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import formatDate from '@/services/general/formatDate';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import { LISTE_INDEX_JOURS } from '@/configuration/datePickerConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import validationEchecAffectation from '@/services/logistique/tourneeFaceSemaine/validationEchecAffectation';
import ucFirst from '@/services/general/ucFirst';
import inProgress from '@/services/general/inProgress';
import { DEMANDE, AFFECTATION } from '@/configuration/logistique/permissionsLogistiqueConf';
import filtreDemande from '@/components/logistique/demande/liste/filtreDemande';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import popUpModifier from '@/components/commande/logistique/p_editionDemande';
import * as demandeConf from '@/configuration/logistique/demande/demandeConf';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import exportExcel from '@/api/exportExcel';
import messageErreur from '@/services/general/messageErreur';
import transformer from '@/services/logistique/demande/demandeLogistiqueServerTableDataTransformer';
import {
  ETAT_DEMANDE_INTERVENTION,
  ETAT_NOUVEAU,
  ETAT_TRAITE,
} from '@/configuration/logistique/intervention/interventionConf';
import selecteurAction from '@/components/general/selecteurAction';
import { updateEtatAsync, deleteAllDemandeLogistique } from '@/api/logistique/demandeLogistique';
import { ACTION_MASS_DELETE } from '@/configuration/general/actionsConf';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import validation from '@/services/logistique/demandeLogistique/validation';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_DEMANDE_AUTO } from '@/configuration/general/referenceTableConf';

const Demande = createNamespacedHelpers('demande');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      unsubscribeValue: null,
      popUpGeneration: false,
      filter: null,
      showFiltre: false,
      permDemande: DEMANDE,
      permAffectation: AFFECTATION,
      popUpModification: false,
      ligneAModifier: null,
      demandeSelectionne: false,
      selectAllValue: false,
      actions: [
        { action: demandeConf.ACTION_CHANGEMENT_ETAT_TRAITE, translation: 'listeDemande.actions.traiteDemande' },
        { action: demandeConf.ACTION_CHANGEMENT_ETAT_NOUVEAU, translation: 'listeDemande.actions.newDemande' },
        { action: ACTION_MASS_DELETE, translation: 'listeDemande.actions.delete' },

      ],
      constantes: {
        TYPE_DEMANDE_LOGISTIQUE: demandeConf.TYPE_DEMANDE_LOGISTIQUE,
        EXPORT_EXCEL_DEMANDES_MANUELLES: demandeConf.EXPORT_EXCEL_DEMANDES_MANUELLES,
        ETAT_DEMANDE_INTERVENTION: ETAT_DEMANDE_INTERVENTION,
      },
      popUpSuppression: false,
      idsToDelete: [],
      messagesPopup: [],
      isErrorPopup: false,
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_DEMANDE_AUTO,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    routerLinkBlank,
    TableItemsInView,
    filtreDemande,
    popUpModifier,
    selecteurAction,
    popUpPrevention,
    parametrageTable,
    exportExcelButton,
  },
  computed: {
    ...Demande.mapGetters({
      demandesLogistiques: 'demandesLogistiques',
      critereRecherche: 'criteresRechercheLogistique',
      dateSelect: 'dateSelect',
      lastPayload: 'lastPayloadLogistique',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      lockMenu: 'lockMenu',
    }),
    nombreCritere() {
      const banCritere = ['auto'];
      return calculNombreCritere(this.critereRecherche, banCritere);
    },
    listeDemandesFilter() {
      return this.demandesLogistiques.filter(item => {
        let find = false;
        [
          item.ligneCommande?.codeCommande,
          item.ligneCommande?.commercial,
          item.ligneCommande?.annonceurs,
          item.ligneCommande?.theme,
          item.libelleProduit,
          item.ville,
          item.messageEchecAffectation,
          item.ligneCommande?.facesVendues.toString(),
        ].forEach((itemSearch) => {
          if (itemSearch
            && itemSearch.toLowerCase().includes(this.critereRecherche.auto.toLowerCase())) {
            find = true;
          }
        });
        return find
          && (this.critereRecherche.produits.length === 0
            || (this.critereRecherche.produits.length > 0
              && this.critereRecherche.produits.some((produit) => {
                return (item.ligneCommande && produit.id === item.ligneCommande.produitId)
                || (item.produit && produit.id === item.produitId);
              })))
          && (this.critereRecherche.typesProduits.length === 0
            || (this.critereRecherche.typesProduits.length > 0
              && this.critereRecherche.typesProduits.some((typeProduit) => {
                return typeProduit === item.typeProduit;
              })));
      });
    },
    iconSelectTotal() {
      if (this.allDemandeSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          codeCommande: this.$t('listeDemande.tab.numCommande'),
          commercial: this.$t('listeDemande.tab.commercial'),
          annonceurs: this.$t('listeDemande.tab.annonceur'),
          theme: this.$t('listeDemande.tab.theme'),
          libelleProduit: this.$t('listeDemande.tab.produit'),
          ville: this.$t('listeDemande.tab.ville'),
          datePlanification: this.$t('listeDemande.tab.datePlanification'),
          dateDebutAffichage: this.$t('listeDemande.tab.dateDebutAffichage'),
          dateFinAffichage: this.$t('listeDemande.tab.dateFinAffichage'),
          semaine: this.$t('listeDemande.tab.semaine'),
          jourDepart: this.$t('listeDemande.tab.jourDepart'),
          facesVendues: this.$t('listeDemande.tab.nbFacesDemandees'),
          facesAffectees: this.$t('listeDemande.tab.nbFacesAffecter'),
          typeProduit: this.$t('listeDemande.tab.nature'),
          etat: this.$t('listeDemande.tab.etat'),
          actionLogistique: this.$t('listeDemande.tab.actionLogistique'),
          couleur: '',
          affecter: '',
          modifier: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        columnsClasses: {
          affecter: 'is-paddingless',
          modifier: 'colonneSelected-35 ',
          selected: 'colonneSelected',
        },
        sortable: ['actionLogistique', 'codeCommande', 'commercial', 'annonceurs', 'theme', 'libelleProduit', 'datePlanification', 'typeProduit', 'ville', 'dateDebutAffichage', 'dateFinAffichage', 'semaine', 'jourDepart', 'facesVendues', 'facesAffectees'],
      };
    },
    columns() {
      return ['selected', 'libelleProduit', 'ville', 'typeProduit', 'codeCommande', 'commercial', 'annonceurs', 'theme', 'datePlanification', 'actionLogistique', 'dateDebutAffichage', 'dateFinAffichage', 'facesVendues', 'facesAffectees', 'couleur', 'etat', 'modifier', 'affecter'];
    },
    allDemandeSelected() {
      return this.getAllDemandeSelected().length === this.demandesLogistiques.length;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    getAllDemandeSelected() {
      return this.demandesLogistiques.filter((el) => {
        return el.selected;
      });
    },
    selectAll() {
      const select = !this.allDemandeSelected;
      this.demandesLogistiques.forEach((el) => {
        el.selected = select;
      });
    },
    async updateEtatDemande(etat) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const data = {
          demandeIds: this.getAllDemandeSelected().map((el) => el.id),
          etat: etat,
        };
        await updateEtatAsync(data);
        this.$emit('refreshList');
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    handleAction(action) {
      switch (action) {
        case demandeConf.ACTION_CHANGEMENT_ETAT_NOUVEAU:
          this.updateEtatDemande(ETAT_NOUVEAU);
          break;
        case demandeConf.ACTION_CHANGEMENT_ETAT_TRAITE:
          this.updateEtatDemande(ETAT_TRAITE);
          break;
        case ACTION_MASS_DELETE:
          if (this.checkPermissions(this.permDemande.supprimer)) {
            this.popUpSuppression = true;
            this.idsToDelete = this.getAllDemandeSelected().map((el) => el.id);
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n);
          break;
      }
    },
    updateValue(id, newValue) {
      const demande = this.demandesLogistiques.find((demande) => {
        return demande.id === id;
      });
      demande.selected = newValue;
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreDemande.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
    },
    reinitialiserFiltre() {
      this.$refs.filtreDemande.initializeFiltre();
      this.$refs.filtreDemande.viderCritere();
      this.$refs.filtreDemande.appliquerCritere();
      this.showFiltre = false;
    },
    getDateFormate(date) {
      return formatDate(date);
    },
    isRegroupement(type) {
      return type === produitConf.CATEGORIE_REGROUPEMENT
      || type === produitConf.CATEGORIE_REGROUPEMENT_LC
      || type === produitConf.CATEGORIE_REGROUPEMENT_MAIRIE;
    },
    modifier(ligne) {
      if (!this.checkPermissions(this.permAffectation.maj)) {
        this.showPopUp();
        return;
      }
      if (ligne.estDansOtAffichage) {
        return;
      }
      this.ligneAModifier = ligne;
      this.popUpModification = true;
    },
    getLibelleAndRoutesForProduct(demande) {
      const produitConfiguration = produitConf.CATEGORIE_PRODUIT.find(
        (produitObject) => {
          return produitObject.code === demande.typeProduit;
        },
      );
      return produitConfiguration;
    },
    aAffichageMemeSemaine(demande) {
      return ((!this.isRegroupement(demande.ligneCommande.typeProduit)
         && getAnneeSemaineFromDate(demande.datePlanification)
          === getAnneeSemaineFromDate(demande.ligneCommande.datePlanifieeLogistiqueAffichage))
         || (this.isRegroupement(demande.ligneCommande.typeProduit)
         && getAnneeSemaineFromDate(demande.datePlanification)
          === getAnneeSemaineFromDate(demande.ligneCommande.dateDebut)));
    },
    estAffectee(ligne) {
      return ligne.facesAffectees >= ligne.facesDemandees;
    },
    getMessageEchecAffectation(ligne) {
      return validationEchecAffectation(ligne.messageEchecAffectation);
    },
    getLibelleTypeProduit(type) {
      const typeFind = produitConf.CATEGORIE_PRODUIT.find((prod) => {
        return prod.code === type;
      });
      return typeFind ? typeFind.libelle : null;
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getEtatDemande(demande) {
      if (demande.etat === ETAT_TRAITE) {
        return this.$t(ETAT_DEMANDE_INTERVENTION.find((etat) => {
          return etat.key === ETAT_TRAITE;
        }).libelle);
      }
      if (demande.ligneCommande && demande.ligneCommande.quantiteFacesAffectees === 0) {
        return this.$t('listeDemande.tab.etatList.aTraiter');
      }
      return this.$t('listeDemande.tab.etatList.auto');
    },
    formatageOuputDatepicker() {
      const semaine = (getAnneeSemaineFromDate(this.dateSelect)).substr(4);
      const dateDebut = moment(this.dateSelect).startOf('week').toDate();
      const dateFin = moment(this.dateSelect).endOf('week').toDate();
      return this.$i18n.t('listeDemande.weekWithDate', {
        week: semaine, dateDebut: formatDate(dateDebut), dateFin: formatDate(dateFin),
      });
    },
    getSemaine(ligne) {
      let week = null;
      if (ligne.typeProduit === produitConf.CATEGORIE_REGROUPEMENT) {
        week = ligne.anneeSemaine.toString().substr(4);
      } else {
        week = getAnneeSemaineFromDate(ligne.datePlanifieeLogistiqueAffichage)
          .toString().substr(4);
      }
      return this.$i18n.t('listeDemande.week', { week: week });
    },
    getJourDeLaSemaine(number) {
      return ucFirst(LISTE_INDEX_JOURS.find((jour) => { return jour.number === number; }).libelle);
    },
    allerAAffecter(demande) {
      if (!this.isRegroupement(demande.typeProduit)) {
        return;
      }
      if (!this.checkPermissions(this.permAffectation.maj)) {
        this.showPopUp();
        return;
      }
      this.$router.push({
        name: 'm.logistique.demande-manuel',
        params: {
          idDemande: demande.id,
        },
      });
    },
    async exportExcel() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: this.constantes.EXPORT_EXCEL_DEMANDES_MANUELLES,
          typeExport: null,
          filtres: {
            query: transformer({
              ...this.lastPayload,
              query: {
                ...this.lastPayload.query,
                autoFilter: this.critereRecherche.auto,
                produits: this.critereRecherche.produits.length
                  ? this.critereRecherche.produits.map(el => el.id) : [],
                typeProduit: this.critereRecherche.typesProduits.length
                  ? this.critereRecherche.typesProduits.map(el => el.code) : [],
              },
              orderBy: this.$refs[this.referenceTable].$refs.table.orderBy.column,
              ascending: this.$refs[this.referenceTable].$refs.table.orderBy.ascending,
            }),
          },
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async deleteMassDemandeLogistique() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.isErrorPopup = false;
        this.messagesPopup = [];
        await deleteAllDemandeLogistique(this.idsToDelete);
        this.popUpSuppression = false;
        messageSucces(this.idsToDelete.length === 1
          ? this.$t('listeDemande.messages.success.DemandeDelete') : this.$t('listeDemande.messages.success.demandeMulti'));
        this.$emit('refreshList');
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validation(e.response, this.messagesPopup);
          this.isErrorPopup = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
  },
  mounted() {
    this.setInformationPage(this.$t('pageLogistique.demande.listeDemandeManuel'));
  },
};
</script>
